import { Capacitor } from "@capacitor/core";

const configuredOrigin = process.env.REACT_APP_ADSERVER_URL?.replace(/\/$/, "");
const browserOrigin =
  typeof window !== "undefined" ? window.location.origin : "";
const isLocalBrowser = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(
  browserOrigin,
);

export const observerBackendOrigin =
  configuredOrigin ||
  (Capacitor.isNativePlatform()
    ? "https://observertheory.com"
    : isLocalBrowser
      ? "http://localhost:3000"
      : browserOrigin);
